import { HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { CredentialService } from "src/app/modules/authentication/credential.service";
import { environment } from "src/environments/environment";
import { AUTH_API } from "../apis/auth.api";

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const credentialService = inject(CredentialService);
  const token = credentialService.getAccessToken();

  if (token && !unAuthenticatedApis.includes(request.url)) {
    const authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next(authRequest);
  }
  return next(request);
};

const unAuthenticatedApis: string[] = [
  environment.BASE_URL + AUTH_API.REFRESH_ACCESS_TOKEN,
  environment.BASE_URL + AUTH_API.FORGET_PASSWORD,
  environment.BASE_URL + AUTH_API.RESET_PASSWORD,
  environment.BASE_URL + AUTH_API.LOGIN,
];
